import { ClientIDType } from '../../types';
import { I18n } from '../../wrappers';
import Client from '../Client';
export class ClientLocalizationSr {
    client;
    constructor(client) {
        this.client = client;
    }
    static idTypes() {
        return [
            { id: ClientIDType.tax_id_number_local, text: I18n.t('clients.id_types.tax_id_number_local'), prefix: '10' },
            { id: ClientIDType.personal_id_number_local, text: I18n.t('clients.id_types.personal_id_number_local'), prefix: '11' },
            { id: ClientIDType.tax_id_number_local_jbkjs, text: I18n.t('clients.id_types.tax_id_number_local_jbkjs'), prefix: '12' },
            { id: ClientIDType.retiree_card_number, text: I18n.t('clients.id_types.retiree_card_number'), prefix: '13' },
            { id: ClientIDType.agricultural_holding_tax_id_number, text: I18n.t('clients.id_types.agricultural_holding_tax_id_number'), prefix: '14' },
            { id: ClientIDType.agricultural_holding_personal_id_number, text: I18n.t('clients.id_types.agricultural_holding_personal_id_number'), prefix: '15' },
            { id: ClientIDType.agricultural_holding_id_number, text: I18n.t('clients.id_types.agricultural_holding_id_number'), prefix: '16' },
            { id: ClientIDType.personal_id_card_number, text: I18n.t('clients.id_types.personal_id_card_number'), prefix: '20' },
            { id: ClientIDType.resident_number_refugee, text: I18n.t('clients.id_types.resident_number_refugee'), prefix: '21' },
            { id: ClientIDType.resident_number_foreign, text: I18n.t('clients.id_types.resident_number_foreign'), prefix: '22' },
            { id: ClientIDType.passport_number_local, text: I18n.t('clients.id_types.passport_number_local'), prefix: '23' },
            { id: ClientIDType.passport_number_foreign, text: I18n.t('clients.id_types.passport_number_foreign'), prefix: '30' },
            { id: ClientIDType.resident_number_diplomat, text: I18n.t('clients.id_types.resident_number_diplomat'), prefix: '31' },
            { id: ClientIDType.personal_id_card_number_mkd, text: I18n.t('clients.id_types.personal_id_card_number_mkd'), prefix: '32' },
            { id: ClientIDType.personal_id_card_number_mne, text: I18n.t('clients.id_types.personal_id_card_number_mne'), prefix: '33' },
            { id: ClientIDType.personal_id_card_number_alb, text: I18n.t('clients.id_types.personal_id_card_number_alb'), prefix: '34' },
            { id: ClientIDType.personal_id_card_number_bih, text: I18n.t('clients.id_types.personal_id_card_number_bih'), prefix: '35' },
            { id: ClientIDType.personal_id_card_number_eur, text: I18n.t('clients.id_types.personal_id_card_number_eur'), prefix: '36' },
            { id: ClientIDType.tax_id_number_foreign, text: I18n.t('clients.id_types.tax_id_number_foreign'), prefix: '40' },
        ];
    }
    getFullIdNumber() {
        const idType = Client.idTypes().find(type => type.id === this.client.id_type);
        if (idType)
            return `${idType.prefix}:${this.client.id_number}`;
        // Legacy/API-created domestic buyers carry the generic tax_id_number type;
        // the backend already treats it as a PIB synonym (Client::findByTaxId), so
        // the request does too instead of dropping the buyer.
        if (this.client.id_type === ClientIDType.tax_id_number && this.client.isLocalCountry()) {
            return `10:${this.client.id_number}`;
        }
        return '';
    }
    getTaxIdNumber() {
        if (this.client.id_type === 'tax_id_number_local')
            return this.client.id_number;
        if (this.client.id_type === 'tax_id_number_local_jbkjs')
            return this.client.id_number ? this.client.id_number.split(':')[0] : '';
        return this.client.tax_id_number || '';
    }
    einvoiceAllowed() {
        const allowedIdTypes = [ClientIDType.tax_id_number_local, ClientIDType.tax_id_number_local_jbkjs, ClientIDType.agricultural_holding_tax_id_number];
        return allowedIdTypes.includes(this.client.id_type)
            && !!this.client.id_number
            && (!!this.client.registration_number || this.client.id_type === ClientIDType.agricultural_holding_tax_id_number)
            && !!this.client.city
            && !!this.client.postal_number
            && !!this.client.country;
    }
    isDiplomat() {
        return this.client.id_type === 'resident_number_diplomat'
            || !!this.client.tax_id_card_number;
    }
    isLocalCountry() {
        return this.client.country === 'SRB';
    }
    isValid() {
        if (!this.isLocalCountry())
            return !!this.client.id_number && !!this.client.id_type;
        return true;
    }
}
const ClientLocalizationSrStatic = ClientLocalizationSr;
//# sourceMappingURL=ClientLocalizationSr.js.map